
function remap(value, in_min, in_max, out_min, out_max ) {
  return (value - in_min) * ((out_max - out_min) / (in_max - in_min)) + out_min;
}

function clamp(x, minVal, maxVal){
  return Math.min(Math.max(x,minVal),maxVal);
}
function clip(x, minVal, maxVal){
  return Math.min(Math.max(x,minVal),maxVal);
}


export {remap, clamp, clip}